import { Spin } from 'antd';
import React from 'react';

type Props = {
  classNames?: string;
};

function FullPageLoader({ classNames }: Props): JSX.Element {
  return (
    <div className={`full-page-loader ${classNames || ''}`}>
      <Spin />
    </div>
  );
}

export default FullPageLoader;
